import { useEffect, useRef } from 'react';

export const useClickOutside = (handler, listenCapturing = true) => {
  const ref = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        handler();
      }
    };

    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        handler();
      }
    };

    document.addEventListener('mousedown', handleClickOutside, listenCapturing);
    document.addEventListener('keydown', handleEscKey, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, listenCapturing);
      document.removeEventListener('keydown', handleEscKey, true);
    };
  }, [handler, listenCapturing]);

  return ref;
}; 